import React from "react";

const AccrdianL1Tabledata = ({ data, id }) => {
  return <div>{id}</div>;
};

export default AccrdianL1Tabledata;
